import subscriptionsFetcher from './subscriptions-fetcher';

export default {
  subscriptionsFetcher,
};
